import helpBubble from 'assets/helpBubble.svg';
import infoCircle from 'assets/info-circle-pink.svg';
import { BackPage, OrderBar, RejectOrderOverlay, Spinner } from 'components';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { ManualOrderPageContent } from 'services/content.js';
import styles from './style.module.css';

const ManualOrder = () => {
  const history = useHistory();
  const { manualJourney } = useSelector((state) => state);
  const startedJourney = manualJourney?.started;
  const selectedManualOrder = manualJourney?.selectedOrder;
  const [displayRejectOverlay, setDisplayRejectOverlay] = useState(false);
  useEffect(() => {
    if (!startedJourney) history.push('/pharmacy/dashboard');
  }, [history, startedJourney]);
  if (!selectedManualOrder?.order_id)
    return (
      <BackPage onBackClick={() => history.goBack()} pushTop>
        <div className={styles.loadingSpinner}>
          <Spinner />
        </div>
      </BackPage>
    );

  return (
    <>
      {displayRejectOverlay && (
        <RejectOrderOverlay manualOrder={selectedManualOrder} closeOverlay={() => setDisplayRejectOverlay(false)} />
      )}
      <OrderBar currentProgress={0} />
      <BackPage onBackClick={() => history.push('/pharmacy/dashboard')} pushTop>
        <h1>{ManualOrderPageContent.headingText}</h1>
        <div className={styles.manualOrderContainer}>
          <h2>Order #{selectedManualOrder.order_id}</h2>
          <p>GP order placed on {moment(selectedManualOrder.date_requested).format('dddd DD MMMM YYYY')}</p>
          <hr className={styles.horizontalRow} />
          <div className={styles.manualOrderRow}>
            <img src={infoCircle} className={styles.icon} alt={`Information`} />
            <div>
              <h2>{ManualOrderPageContent.informationHeader}</h2>
              <p>{ManualOrderPageContent.informationText}</p>
            </div>
          </div>
          <div className={`${styles.manualOrderRow} ${styles.spaceBetween}`}>
            <h2>Medication request</h2>
            <h2>
              {selectedManualOrder.order_items.length} item{selectedManualOrder.order_items.length > 1 ? 's' : ''}
            </h2>
          </div>
          <hr className={`${styles.horizontalRow} ${styles.horizontalRowTint}`} />
          {selectedManualOrder.order_items.map((orderItem) => (
            <p key={orderItem.course_id}>{orderItem.name}</p>
          ))}
          <hr className={`${styles.horizontalRow} ${styles.horizontalRowTint}`} />
          <div className={styles.priceDisplay}>
            <h2>Total</h2>
            <h3>
              {selectedManualOrder.total_amount === 0 ? 'Free' : `£${selectedManualOrder.total_amount.toFixed(2)}`}
            </h3>
          </div>
        </div>
        <div className={styles.buttonContainer}>
          <button
            onClick={() => history.push('/pharmacy/dashboard/manual-basket')}
            className={`coop-btn coop-btn--primary ${styles.button}`}>
            {ManualOrderPageContent.acceptButtonText}
          </button>
          <button
            onClick={() => setDisplayRejectOverlay(true)}
            className={`coop-btn coop-btn--tertiary ${styles.button}`}>
            {ManualOrderPageContent.rejectButtonText}
          </button>
        </div>
        <div className={styles.manualOrderContainer}>
          <h3>{ManualOrderPageContent.helpHeader}</h3>
          <a
            tabIndex="0"
            href="https://intercom-help.eu/heypharmacist/en"
            target="_blank"
            rel="noopener noreferrer"
            className={`${styles.helpLink} ${styles.manualOrderRow}`}>
            <img src={helpBubble} className={styles.icon} alt={`Help and support`} />
            <div>{ManualOrderPageContent.helpText}</div>
          </a>
        </div>
      </BackPage>
    </>
  );
};

export default ManualOrder;
